/**
 * Sawyer 03 today-notes-board (C2) — the booking note as staff read it.
 *
 * `bookings.notes` is the visit's note: what the owner typed in "Notes for
 * our team", what the desk typed in Quick Book, or what the Gingr mirror
 * copied from the reservation. The mirror writes it as
 * `[Gingr: <reservation type>] <reservation_notes>`
 * (`apps/server/src/services/gingr-booking-import.ts` composeNotes), so a
 * large share of mirrored rows carry ONLY the label. Shown raw, the label
 * makes every Gingr visit look like it has a note, and the highlight stops
 * meaning "someone wrote something for this visit" (DESIGN-PHILOSOPHY
 * Principle 5, never lie about data).
 *
 * The rule, stated once: strip ONE leading `[Gingr: …]` label (the only shape
 * composeNotes writes), trim, and treat what is left as no note when empty. A
 * `[Gingr: …]` anywhere else is someone's words and is kept verbatim. Nothing
 * is truncated here: the write paths already cap a note at 1000 characters.
 *
 * A LEAF module (no imports): the dashboard route reads it by subpath.
 */

const LEADING_GINGR_LABEL = /^\s*\[Gingr:[^\]]*\]\s*/;

/** The booking note to display, or null when there is nothing to read. */
export function displayBookingNote(raw: string | null | undefined): string | null {
  if (raw === null || raw === undefined) return null;
  const text = raw.replace(LEADING_GINGR_LABEL, '').trim();
  return text.length === 0 ? null : text;
}
